/**
 * ContentSet entity class
 */

/**
 * ContentSetFactory
 * returns ContentSet entity class
 *
 * @class ContentSetFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.ContentSet} class
 *
 * @ngdoc factory
 * @name mwApp.factory:ContentSetFactory
 */
/* @ngInject */
export default function ContentSetFactory ($http, $injector, Entity) {
  /* === ContentSet class === */

  /**
   * ContentSet model
   *
   * @class ContentSet
   * @classdesc ContentSet model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @mixes models.onOffMixin
   * @mixes models.FileUploadMixin
   * @return {models.ContentSet} ContentSet entity
   */
  function ContentSet () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  ContentSet.prototype = Object.create(Entity.prototype)
  ContentSet.prototype.constructor = ContentSet

  /* === ContentSet instance methods & fields === */

  Object.assign(ContentSet.prototype, {

    /**
     * instance fields
     *
     * @memberof models.ContentSet#
     * @type {Object}
     */
    _fields: {
      id: Number,
      name: String,
      networkId: Number,
      networkName: String,
      $itemType: 'vod' | 'channel'
    },

    /**
     * url template
     *
     * @memberof models.ContentSet#
     * @type {String}
     */
    _urlTemplate: 'api/networks/{{::networkId}}/ContentSets/{{::id}}',

    /**
     * public url template
     *
     * @memberof models.ContentSet#
     * @type {String}
     */
    _publicUrlTemplate: 'organizations/{{::networkId}}/contentSets/{{::$itemType}}/{{::id}}',

    /**
     * public url template
     *
     * @memberof models.ContentSet#
     * @type {String}
     */
    _networkUrlTemplate: 'api/networks/{{::networkId}}',

    /**
     * url template for loading custom prices
     *
     * @memberof models.ContentSet#
     * @type {String}
     */
    _customPricesUrlTemplate: 'api/networks/{{::networkId}}/subscriptions/{{::subscriptionId}}/ContentSets/{{::setId}}/prices',

    /**
     * url template for checking set intersection
     *
     * @memberof models.ContentSet#
     * @type {String}
     */
    _contentIntersectionUrlTemplate: 'api/networks/{{::networkId}}/ContentSets/{{::id}}/intersection'

  })

  /* === ContentSet static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(ContentSet, Entity)
  ContentSet._name = 'ContentSet'
  ContentSet._publicName = 'Content Set'
  ContentSet.init()

  // permissions
  ContentSet.access = {
    view: '',
    create: '',
    edit: '',
    delete: ''
  }

  return ContentSet
}
